module.exports = __webpack_public_path__ + "img/fill_system.03d4c33d.jpg";